import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = getLatestArticles(8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              持续更新的同人动画创作内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}